
export function changeDate(valueDate: any , typeDate: number){
  // typeDate date for start => 0 or end => 1
  const getDate = new Date(valueDate);
  console.log(valueDate, getDate);

  const formattedDate = (getDate.getMonth() + 1) + '-' + getDate.getDate()  + '-' + getDate.getFullYear();
  console.log(formattedDate);
  const dateWithTime = typeDate === 0 ? new Date(formattedDate + ' 00:00:00') : new Date(formattedDate + ' 23:59:59');
  console.log(typeDate, dateWithTime);
  const changeToUnix = dateWithTime.getTime() / 1000;
  return changeToUnix;
}
